import BaseApi from "@/api/BaseApi";

export default class Questionaires extends BaseApi {
    construct() {}

    static async create(payload) {
        return this.post(this.getApiUrl(), payload);
    }

    static async index(filters = {}) {
        return this.get(`${this.getApiUrl()}/`, {params: filters});
    }

    static async all(filters = {}) {
        return this.index(filters);
    }

    static async update(id, payload) {
        return this.patch(`${this.getApiUrl()}/${id}`, payload);
    }

    static async submit(id, payload) {
        return this.post(`${this.getApiUrl()}/${id}/submit`, payload);
    }

    static async show(id) {
        return this.get(`${this.getApiUrl()}/${id}`);
    }

    static async active(payload) {
        return this.get(`${this.getApiUrl()}/model/active`, payload)
    };

    static async bulkCreate(payload) {
        return this.post(`${this.getApiUrl()}/bulk-create`, payload);
    }
}